import React from 'react';
import { authorTilePropTypes } from '@Theme/natucare/modules/Authorship/components/AuthorTile/AuthorTilePropTypes';
import Picture from '@Theme/natucare/components/Picture/Picture';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './AuthorTile.module.scss';
const AuthorTile = ({
  href,
  picture,
  name,
  role,
  verifiedLabel,
  details
}) => {
  const Component = href ? 'a' : 'div';
  const avatarSize = {
    width: 90,
    height: 90
  };
  const {
    description,
    socials
  } = details;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, (picture === null || picture === void 0 ? void 0 : picture.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src,
      ...avatarSize
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }), !(picture !== null && picture !== void 0 && picture.src) && /*#__PURE__*/React.createElement("div", {
    role: "presentation",
    className: styles.rootPicture
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "avatarPlaceholder",
    size: avatarSize,
    classname: styles.rootIcon
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.rootContent
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootContentHead
  }, role && /*#__PURE__*/React.createElement("p", {
    className: styles.rootRole
  }, role), /*#__PURE__*/React.createElement("div", {
    className: styles.rootAuthor
  }, /*#__PURE__*/React.createElement(Component, {
    href: href,
    className: styles.rootAuthorLink
  }, name), socials && /*#__PURE__*/React.createElement("div", {
    className: styles.rootAuthorSocials
  }, Object.keys(socials).map((key, index) => socials[key] && /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer nofollow",
    key: index,
    href: socials[key],
    className: styles.rootAuthorSocialsLink
  }, /*#__PURE__*/React.createElement(Icon, {
    name: key,
    size: {
      width: 24,
      height: 24
    }
  })))))), verifiedLabel && /*#__PURE__*/React.createElement("div", {
    className: styles.rootVerified
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "verified",
    classname: styles.rootVerifiedIcon,
    size: {
      width: 20,
      height: 20
    }
  }), verifiedLabel), description && /*#__PURE__*/React.createElement("p", {
    className: styles.rootDescription
  }, description)));
};
export default AuthorTile;